export const parsedReorderItemRequestPayload = (metadata: any, index: number) => {
  const { id } = metadata;
  return {
    id,
    orderPriority: index,
  };
};
